import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import AuthLayout, {
  AuthError,
  authButtonClassName,
  authInputClassName,
  authLabelClassName,
} from "../../components/auth/AuthLayout";

const MfaChallenge: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { completeMfaChallenge } = useAuth();
  const { email, from = "/" } = location.state || {};

  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!email) {
      navigate("/login");
    }
  }, [email, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await completeMfaChallenge(email, code);
      navigate(from, { replace: true });
    } catch (err: any) {
      setError(err.message || "Invalid code. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Two-factor authentication"
      subtitle="Enter the 6-digit code from your authenticator app"
    >
      <form className="w-full space-y-5" onSubmit={handleSubmit}>
        {error && <AuthError message={error} />}

        <div>
          <label htmlFor="code" className={authLabelClassName}>
            Authentication code
          </label>
          <input
            id="code"
            name="code"
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={6}
            required
            autoFocus
            className={`${authInputClassName} text-center text-2xl tracking-[0.5em]`}
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
          />
        </div>

        <button
          type="submit"
          disabled={loading || code.length !== 6}
          className={authButtonClassName}
        >
          {loading ? "Verifying…" : "Verify"}
        </button>
      </form>
    </AuthLayout>
  );
};

export default MfaChallenge;
